import { parseCustomCss } from "../utils";

export const getHoverClassByType = (type) => {
  switch (type) {
    case "section":
      return "section-hovered";
    case "block":
      return "block-hovered";
    case "column":
      return "column-hovered";
    case "field":
      return "field-hovered";
    case "label":
      return "label-hovered";
    case "image":
      return "image-hovered";
    case "button":
      return "button-hovered";
    case "tab":
      return "tab-hovered";
    default:
      return "default-hovered";
  }
};

export const getNodeClassName = ({ node, isEditable, isHovered, isDirectHovered, isSelectedItem, draggedItem }) => {
  const nodeClassNames = node.classes?.join(" ") || "";
  const customClassNames = getCustomClassName({
    node,
    isEditable,
    isHovered,
    isDirectHovered,
    isSelectedItem,
    draggedItem
  });
  return `${customClassNames} ${nodeClassNames}`.trim();
};
export const getCustomClassName = ({ node, isEditable, isHovered, isDirectHovered, isSelectedItem, draggedItem }) => {
  let customClassNames = "";

  if (isEditable && node.type === "section") {
    customClassNames += " outline_class";
  }

  if (isHovered || isSelectedItem || isDirectHovered) {
    if (isDirectHovered && !draggedItem) {
      const hoverType = node.type === "element" ? node.config.type : node.type;
      customClassNames += ` ${getHoverClassByType(hoverType)}`;
    } else {
      customClassNames += " hovered";
    }
  }

  return customClassNames.trim();
};
export const getNodeStyle = (node) => {
  return {
    ...node.style,
    ...(node.config?.inline_style || {}),
    ...(node.config?.custom_css?.trim() ? parseCustomCss(node.config.custom_css) : {})
  };
};
